if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.cartNotification = $('.cart-notification');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.disabled) return;

        this.handleErrorMessage();

        //this.cartNotification.setActiveElement(document.activeElement);

        this.submitButton.disabled = true;
        this.submitButton.setAttribute('aria-busy', 'true');
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove(
          'hidden',
        );

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        //formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        formData.append('sections[]', 'section_header');
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              const soldOutMessage =
                this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            if (response?.sections && response?.sections?.section_header) {
              const text = response.sections.section_header;
              if (typeof text === 'string' && text.trim()) {
                const parser = new DOMParser();
                const html = parser.parseFromString(text, 'text/html');
                const trackingInfoUpdated =
                  html.querySelector('#MiniCartTrack');
                const oldTrackingInfo =
                  window.document.getElementById('MiniCartTrack');
                if (oldTrackingInfo && trackingInfoUpdated) {
                  oldTrackingInfo.innerHTML = trackingInfoUpdated.innerHTML;
                }
              }
            }

            this.error = false;

            const addedToCartMessage = document.getElementById(
              'message-add-to-cart',
            );
            if (addedToCartMessage) {
              addedToCartMessage.textContent =
                window.translations.addedToCartMessage;
            }

            const quickAddModal = this.closest('quick-add-modal');
            window?.OcShopify?.trackAddToCart(response.url, {
              discount: {
                line_discount: response.line_level_discount_allocations,
                discounts: response?.discounts,
              },
            });
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cartNotification.renderContents(response);
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              //this.cartNotification.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
              //this.cartNotification.addClass('active').show();
              $('#cart-notification').minicart();
            }
            this.querySelector('.loading-overlay__spinner').classList.add(
              'hidden',
            );
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message',
          );

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        this.error = true;
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}
